var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"cnt-search container"},[_c('Search',{attrs:{"modifyInput":_vm.modifyInput}})],1),_c('Data',{attrs:{"toSearch":_vm.toSearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }